<div class="modal-title d-flex justify-content-between align-items-center">
  <h3 [title]="title">{{ title }}</h3>
  <div *ngIf="closeCallback" class="modal-title-close d-flex align-items-center" (click)="closeCallback()">
    <svg-icon class="clear-icon" [src]="'/assets/img/close-icon.svg'"></svg-icon>
  </div>
  <div *ngIf="!closeCallback" class="modal-title-close d-flex align-items-center" mat-dialog-close>
    <svg-icon class="clear-icon" [src]="'/assets/img/close-icon.svg'"></svg-icon>
  </div>
</div>
